/**
 * LINKEDIN POST API — Wrapper dei REST Liferay allineato a LinkedinPostsResourceImpl.java.
 * I 5 metodi CRUD standard vengono da `createCrudApi`.
 *
 * Contratto backend (rest-openapi.yaml):
 *   - GET    /linkedin-posts/{groupId}   (+ page, pageSize, sort, search) -> Page<LinkedinPost>
 *   - POST   /linkedin-posts/{groupId}  LinkedinPostInput                 -> LinkedinPost
 *   - GET    /linkedin-post/{linkedinPostId}                              -> LinkedinPost
 *   - PATCH  /linkedin-post/{linkedinPostId}  LinkedinPostInput (parziale) -> LinkedinPost
 *   - DELETE /linkedin-post/{linkedinPostId}                              -> 200
 *
 * Nessun `direction` nel path (a differenza di Call/Email).
 * `linkedinPostUpdateToInput` ignora `linkedinPostId` (whitelist).
 */

import type { ServerListParams } from '@crm/shared';
import { createCrudApi } from '../../store/createCrudApi';
import {
  linkedinPostFromDto,
  linkedinPostCreateToInput,
  linkedinPostUpdateToInput,
  type LinkedinPostDto,
} from './linkedinPostMappers';
import type {
  LinkedinPost,
  LinkedinPostCreatePayload,
  LinkedinPostUpdatePayload,
} from './linkedinPostTypes';

export const linkedinPostApi = createCrudApi<
  LinkedinPost,
  LinkedinPostDto,
  LinkedinPostCreatePayload,
  LinkedinPostUpdatePayload,
  ServerListParams
>({
  collection: '/linkedin-posts',
  single: '/linkedin-post',
  fromDto: linkedinPostFromDto,
  createToInput: linkedinPostCreateToInput,
  updateId: (p) => p.linkedinPostId,
  updateToInput: (p) => linkedinPostUpdateToInput(p),
});
